import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=2ef99843&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=2ef99843&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef99843",
  null
  
)

export default component.exports